import {
    DropdownData,
    DropdownFilterContext,
    FilteredValue,
    InputType,
    Form,
    FormField,
    FormSection,
    FormType,
    ReactiveFormLifecycleEvent,
    ReactiveFormStableValueChange,
    ReactiveFormValue,
} from '@fitogest/reactive-form-builder/interfaces';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { build, list, pool, ReactiveSelectionResolver } from '@fitogest/reactive-form-builder/utils';
import { CultivosVariedadApiService } from '../../../../../service/api/cultivos-variedad-api.service';
import { VisitasApiService } from '../../../../../service/api/visitas-api.service';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { BaseForm } from '../../../../../view/base-form';
import { environment } from '../../../../../../environments/environment';

import { VariedadSIEXModel } from 'src/app/models/visitas_variedad_mes/variedadSIEX.model';
type DropdownDataWithRawData<T> = DropdownData<T> & { data?: T[] | T };
import { CultivoSIEXModel } from 'src/app/models/visitas_variedad_mes/cultivoSIEX.model';
import { catchError, map, of } from 'rxjs';
import { SeguimientoModel } from 'src/app/models/visitas/seguimiento.model';
import { FileUploadAnswer } from 'src/app/common/utils';

@Component({
    selector: 'app-viveros-pereira-form',
    standalone: false,
    templateUrl: './viveros-pereira-form.component.html',
    styleUrls: ['./viveros-pereira-form.component.scss']
})
export class ViverosPereiraFormComponent extends BaseForm<SeguimientoModel> implements OnInit {


    public override model: SeguimientoModel = {};
    public adjunto: string | ArrayBuffer | null | undefined;

    public reactiveForm!: { formType: FormType; model: ReactiveFormValue<SeguimientoModel>; formFields: Form<SeguimientoModel> };

    public readonly reactiveFormLoadingLabel = 'Preparando formulario de viveros Pereira...';

    public isReactiveFormReady = false;

    public reactiveFormLoadingError = '';

    public initialPreviousData: SeguimientoModel | null = null;

    public reactiveFormRecordId = '';

    public distributionOrder = [
        3, 3, 3
    ];

    public cultivos: DropdownData<CultivoSIEXModel> = list<CultivoSIEXModel>(['...', null]);
    public variedades: DropdownData<VariedadSIEXModel> = list<VariedadSIEXModel>(['...', null]);

    public etiquetas = list(['Estudio', '1'], ['Germinación', '2'], ['Plaga', '3'], ['Deficiencia', '4'],
        ['Bloqueo', '5'], ['Deformaciones', '6'], ['Marcas', '7'], ['Alteración color', '8'], ['Marchitamiento', '9'], ['Pequeña', '10'],
        ['Grande', '11'], ['Espigada', '12'], ['Estrechamiento cuella', '13'], ['Problema raiz', '14'], ['Mejora', '15'], ['Novedad', '16'],
        ['Error', '17'], ['Lucha biologica', '18']);

    public semanaSiembra = list<string>(['...', null]);
    public semanaEntrega = list<string>(['...', null]);

    public formFieldsLeft: FormField<any>[] = [
    {
        name: 'año',
        field: 'año',
        label: 'Año',
        input: { type: InputType.TEXT, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'semana',
        field: 'semana',
        label: 'Semana',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'fecha',
        field: 'fecha',
        label: 'Fecha',
        input: { type: InputType.CALENDAR, isEditable: true, calendarConfiguration: { calendarView: 'date', calendarDateFormat: 'dd/mm/yy' } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
    {
        name: 'id_cultivo',
        field: 'id_cultivo',
        label: 'Planta',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.cultivos, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.cultivos,

        order: 4
    },
    {
        name: 'id_variedad',
        field: 'id_variedad',
        label: 'Variedad',
        input: {
            type: InputType.DROPDOWN_SEARCH,
            isEditable: true,
            data: this.variedades,
            dropdownConfiguration: {
                valuePrimaryKey: 'id',
                filter: (option: FilteredValue<VariedadSIEXModel>, context?: DropdownFilterContext<VariedadSIEXModel>) =>
                    this.filterVariedadByCultivo(option, context),
            },
            optionLabel: 'label',
            optionValue: 'value'
        },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.variedades,

        order: 5
    },
    {
        name: 'semana_siembra',
        field: 'semana_siembra',
        label: 'Semana Siembra',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.semanaSiembra, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.semanaSiembra,

        order: 6
    },
    {
        name: 'semana_entrega',
        field: 'semana_entrega',
        label: 'Semana Entrega',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.semanaEntrega, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.semanaEntrega,

        order: 7
    },
    {
        name: 'remesa',
        field: 'remesa',
        label: 'Remesa',
        input: { type: InputType.ONLY_TEXT, isEditable: false, maxLength: 4 },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 8
    },
    {
        name: 'observaciones',
        field: 'observaciones',
        label: 'Observaciones',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { rows: 10, hasVoiceTranscription: Boolean(true), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 9
    },
    {
        name: 'adjunto',
        field: 'adjunto',
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 10
    },
];

    public formFieldsMiddle: FormField<any>[] = [
    {
        name: 'cuestiones',
        field: 'cuestiones',
        label: 'Cuestiones',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { rows: 10, hasVoiceTranscription: Boolean(true), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 1
    },
    {
        name: 'medida',
        field: 'medida',
        label: 'Medida',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { rows: 10, hasVoiceTranscription: Boolean(true), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 2
    },
    {
        name: 'resultados',
        field: 'resultados',
        label: 'Resultados',
        input: { type: InputType.TEXTAREA, isEditable: true, textAreaConfiguration: { rows: 10, hasVoiceTranscription: Boolean(true), canTakePhoto: false, photoField: undefined } },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 3
    },
];

    public formFieldsRight: FormField<any>[] = [
    {
        name: 'etiquetas',
        field: 'etiquetas',
        label: 'Etiquetas',
        input: { type: InputType.MULTISELECT_SEARCH, isEditable: true, data: this.etiquetas, dropdownConfiguration: { hasMaxHeight: Boolean(true) }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.etiquetas,

        order: 1
    },
];


    private createReactiveForm(): void {
        const formType = Number(this.getType()) as FormType;
        this.reactiveForm = {
            formType,
            model: this.toSeguimientoFormValue(this.model),
            formFields: {
                name: 'seguimiento',
                header: this.getType() === FormType.EDITION ? this.headerTitleWhenEdit : this.headerTitleWhenNew,
                type: formType,
                sections: this.getReactiveSections(),
                table: null,
                uploadButton: { isEnabled: Boolean(false), label: '' },
                signed: Boolean(false),
                dropdownCatalogs: {
                    critical: [],
                    deferred: ['id_cultivo'],
                    lazy: ['id_variedad'],
                },
                previousDataTransform: (previousData: SeguimientoModel): SeguimientoModel => this.toSeguimientoModel(previousData),
            },
        };
    }

    private getReactiveSections(): FormSection<SeguimientoModel>[] {
        return [
            { name: 'Datos principales', fields: this.formFieldsLeft, width: 12, isVisible: true, order: 1 },
            { name: 'Seguimiento', fields: this.formFieldsMiddle, width: 12, isVisible: true, order: 2 },
            { name: 'Entrega', fields: this.formFieldsRight, width: 12, isVisible: true, order: 3 },
        ];
    }

    public stableValueChanges(event: ReactiveFormStableValueChange<SeguimientoModel>): void {
        const stableValue = this.captureStableValueChange(event.value as SeguimientoModel);

        this.reactiveForm.model = this.toSeguimientoFormValue(stableValue);
        this.syncModelFromForm();

        if (event.origin !== 'user') {
            return;
        }

        this.handleFormValueChange(event.value, event.changedField);
    }

    public onReactiveFormLifecycleEvent(event: ReactiveFormLifecycleEvent<SeguimientoModel>): void {
        if (event.type !== 'previousDataPatched' && event.type !== 'previousDataChanged' && event.type !== 'dropdownRefresh') {
            return;
        }

        const stableValue = this.captureStableValueChange(event.value as SeguimientoModel);

        this.reactiveForm.model = this.toSeguimientoFormValue(stableValue);
        this.syncModelFromForm();
    }

    constructor(public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public visitasApi: VisitasApiService,
        public visitasVariedades: VisitasApiService,
        public override router: Router,
        public http: HttpClient ,
        public cultivosVariedadApi: CultivosVariedadApiService
    ) {
        super(route,
            router,
            dashboard,
            visitasApi.visitasPereira.PUT,
            visitasApi.visitasPereira.POST ,
            'seguimiento',
            'Editar Seguimiento',
            'Crear Seguimiento',
            'Duplicar Seguimiento'
        );
        for (let numeroSemana = 1; numeroSemana <= 52; numeroSemana++) {
            this.semanaSiembra.filtered.push({
                label: numeroSemana.toString(),
                value: numeroSemana.toString(),
            });

            this.semanaEntrega.filtered.push({
                label: numeroSemana.toString(),
                value: numeroSemana.toString(),
            });
        }
    }

    ngOnInit(): void {
        void this.initializeViverosPereiraForm();
    }

    private async initializeViverosPereiraForm(): Promise<void> {
        try {
            this.isReactiveFormReady = false;
            this.reactiveFormLoadingError = '';
            this.resetExternalDropdowns();
            const date = new Date();
            const routeModel = this.toSeguimientoModel(this.getModel() as unknown as Record<string, unknown>);

            this.model = this.toSeguimientoModel({
                ...this.model,
                ...routeModel,
                año: date.getFullYear(),
            });
            this.softInit(this.getType());
            this.reactiveFormRecordId = this.resolveReactiveFormRecordId(routeModel);
            this.initializeHostModel(this.model);
            this.createReactiveForm();
            if (this.getType() === FormType.CREATION) {
                this.model.fecha = new Date();
                this.reactiveForm.model = this.toSeguimientoFormValue(this.model);
                this.updateHostModel(this.model);
            }
            this.initialPreviousData = this.getInitialPreviousData(routeModel);
            await this.initFormData();
            this.markReactiveFormReady();
        } catch (error: unknown) {
            this.reactiveFormLoadingError = this.getReadableInitialisationError(error);
            this.finalizeExternalDropdowns();
            console.error('No se ha podido preparar el formulario de viveros Pereira.', error);
        }
    }

    initFormData(): Promise<boolean> {
        return pool([
            build(this.cultivosVariedadApi.cultivosSiex.GET, this.cultivos, ['cultivo']),
            build(this.cultivosVariedadApi.variedadSiex.GET, this.variedades, ['variedad'], true),
        ], () => undefined).then(() => true);
    }


    private handleFormValueChange(
        formModel: ReactiveFormValue<SeguimientoModel>,
        changedField: string | number | symbol | null | undefined,
    ): void {
        this.reactiveForm.model = this.toSeguimientoFormValue(formModel);
        this.syncModelFromForm();
        this.handleUserValueChange(String(changedField ?? ''));
    }

    private handleUserValueChange(tag: string): void {

        if (tag === 'fecha'){
            this.model.semana = this.getWeekNumberFromISOString(this.model.fecha as string);
        }

        if (tag === 'id_cultivo' || tag === 'id_variedad'){
            this.model.cultivo = this.resolveSelectedCultivo()?.cultivo ?? '';
            this.model.variedad = this.resolveSelectedVariedad()?.variedad ?? '';
        }

        if (tag === 'semana_siembra' || tag === 'semana_entrega'){
            const semanaSiembra =
              this.model.semana_siembra as number < 10 ?
                  '0' + this.model.semana_siembra :
                  this.model.semana_siembra ?
                      this.model.semana_siembra : '00';
            const semanaEntrega =
              this.model.semana_entrega as number < 10 ?
                  '0' + this.model.semana_entrega :
                  this.model.semana_entrega ?
                      this.model.semana_entrega : '00';
            this.model.remesa = semanaSiembra + '' + semanaEntrega;
        }
    }

    private filterVariedadByCultivo(
        option: FilteredValue<VariedadSIEXModel>,
        context?: DropdownFilterContext<VariedadSIEXModel>,
    ): boolean {
        const selectedCultivo = this.resolveSelectedCultivo(context);

        return selectedCultivo === null || option.value?.codigo_cultivo === selectedCultivo.codigo;
    }

    private resolveSelectedCultivo(
        context?: { readonly model: { get(path: string): { readonly value: unknown } | null } },
    ): CultivoSIEXModel | null {
        const currentValue = context?.model.get('id_cultivo')?.value ?? this.model['id_cultivo'];

        return this.resolveSelectedDropdownEntity(this.cultivos, currentValue);
    }

    private resolveSelectedVariedad(): VariedadSIEXModel | null {
        return this.resolveSelectedDropdownEntity(this.variedades, this.model['id_variedad']);
    }

    private resolveSelectedDropdownEntity<T extends object>(dropdownData: DropdownDataWithRawData<T>, value: unknown): T | null {
        return ReactiveSelectionResolver.resolveSelectedEntities(dropdownData, value)[0]
            ?? this.resolveSelectedDropdownDataEntity(dropdownData.data, value);
    }

    private resolveSelectedDropdownDataEntity<T extends object>(data: T[] | T | undefined, value: unknown): T | null {
        const selectedTokens = ReactiveSelectionResolver.extractIdTokens(value);

        if (selectedTokens.size === 0 || data === undefined) {
            return null;
        }

        const entities = Array.isArray(data) ? data : [data];

        return entities.find((entity) => ReactiveSelectionResolver.matchesValue(entity, selectedTokens)) ?? null;
    }

    private markReactiveFormReady(): void {
        this.isReactiveFormReady = true;
        this.finalizeExternalDropdowns();
        this.refreshReactiveDropdownMappings();
    }

    private syncModelFromForm(): void {
        const normalizedModel = this.toSeguimientoModel(this.reactiveForm.model);

        this.reactiveForm.model = this.toSeguimientoFormValue(normalizedModel);
        this.updateHostModel(normalizedModel);
    }

    private refreshReactiveDropdownMappings(): void {
        this.formBuilderRef?.requestExternalDropdownMappingsRefresh();
    }

    private getInitialPreviousData(routeModel: SeguimientoModel): SeguimientoModel | null {
        return Object.keys(routeModel as Record<string, unknown>).length === 0
            ? null
            : this.toSeguimientoModel(routeModel as unknown as Record<string, unknown>);
    }

    private getReadableInitialisationError(error: unknown): string {
        if (error instanceof Error && error.message.trim() !== '') {
            return `No se ha podido cargar el formulario de viveros Pereira: ${error.message}`;
        }

        return 'No se ha podido cargar el formulario de viveros Pereira. Revisa la conexión y vuelve a intentarlo.';
    }

    private toSeguimientoModel(
        value: Record<string, unknown> | ReactiveFormValue<SeguimientoModel> | SeguimientoModel,
    ): SeguimientoModel {
        return { ...(value as Record<string, unknown>) } as unknown as SeguimientoModel;
    }

    private toSeguimientoFormValue(
        value: Record<string, unknown> | ReactiveFormValue<SeguimientoModel> | SeguimientoModel,
    ): ReactiveFormValue<SeguimientoModel> {
        return { ...(value as Record<string, unknown>) } as ReactiveFormValue<SeguimientoModel>;
    }

    getWeekNumberFromISOString(date: string): number {
        const newYear = new Date(new Date(date).getFullYear(), 0, 1);
        let day = newYear.getDay() - 1; // the day of week the year begins on
        day = day >= 0 ? day : day + 7;
        const dayNumber: number =
      Math.floor(
          (new Date(date).getTime() -
          newYear.getTime() -
          (new Date(date).getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) /
        86400000
      ) + 1;
        let weekNumber: number;
        // if the year starts before the middle of a week
        if (day < 4) {
            weekNumber = Math.floor((dayNumber + day - 1) / 7) + 1;
            if (weekNumber > 52) {
                const nYear = new Date(new Date(date).getFullYear() + 1, 0, 1);
                let nday = nYear.getDay() - 1;
                nday = nday >= 0 ? nday : nday + 7;

                /*  if the next year starts before the middle of
             the week, it is week #1 of that year  */

                weekNumber = nday < 4 ? 1 : 53;
            }
        } else {
            weekNumber = Math.floor((dayNumber + day - 1) / 7);
        }
        return weekNumber;
    }

    // Adjuntos
    public readUrl(input: HTMLInputElement) {
        input.click();
        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.adjunto = e.target?.result;
            };
            reader.readAsDataURL(input.files[0]);
            const r = this.http.post(environment.serverUrl + 'ws/seguimiento/upload_file.php', this.adjunto).subscribe(res => {
                const file = res as FileUploadAnswer;
                this.model.adjunto = file.fileName;
                r.unsubscribe();
            });
        }
    }
    public verAdjunto() {
        const myWindow = window.open('about:blank', '_blank', 'width=600, height=600');
        if (myWindow) {
            myWindow.location.assign(environment.serverUrl + 'fotos_seguimiento/' + this.model.adjunto);
            myWindow.focus();
        }
    }

    public fileChange(event: Event) {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            const fileList: FileList = input.files;
            if (fileList.length > 0) {
                const file: File = fileList[0] ?? new File([],'');
                const formData: FormData = new FormData();
                formData.append('uploadFile', file, file.name);
                const headers = new HttpHeaders();
                headers.append('Content-Type', 'multipart/form-data');
                headers.append('Accept', 'application/json');

                const name: string[] = file.name.split('.');
                const ext = name[name.length - 1];
                const accepted = ['gif', 'jpeg', 'jpg', 'jiff', 'png', 'svg', 'tiff'];
                let cond = false;

                for (const e of accepted) {
                    if (e === ext) {
                        cond = true;
                    }
                }

                if (cond) {
                    this.http.post<FileUploadAnswer>(
                        `${environment.serverUrl}ws/seguimiento/upload_file.php`,
                        formData,
                        {headers: headers}
                    ).pipe(
                        map(data => {
                            const res = data || {};
                            this.model.adjunto = res.fileName;
                        }),
                        catchError(error => {
                            console.log(error);
                            return of(null);
                        })
                    ).subscribe();
                } else {
                    alert('Formato de imágen no válido.');
                    this.model.adjunto = '';
                }
            }
        }
    }
}